import { InjectionToken } from '@angular/core';
import { IDrugDetailService } from './drug-detail-service.interface';

export const DRUG_DETAIL_SERVICE = new InjectionToken<IDrugDetailService>(
  'DRUG_DETAIL_SERVICE'
);
